module.exports = __webpack_public_path__ + "static/img/fail.98f3caef.png";